import React from 'react';

const AssessmentPrompt = ({promptData}) => {
  return (
    <div>
      { promptData.can_show_prompt && (
        <a href={ promptData.url }>
          <div className={ `m-t-xs cui-promotion-prompt cui-promotion-prompt-sidebar-padding ${ promptData.prompt_container_classes }` }>
            <div className="cui-promotion-prompt-content">
              <div>{ promptData.text }</div>
              <div><i className="fa-solid fa-arrow-right"></i></div>
            </div>
          </div>
        </a>
      )}
    </div>
  )
}

export default AssessmentPrompt;